import {
  motion,
  useScroll,
  useTransform,
} from "motion/react";
import { useRef } from "react";
import confetti from "@hiseb/confetti";

export function DentistButton() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });
  const progress = useTransform(scrollYProgress, [0, 1], [0, 1], {
    clamp: true,
  });

  return (
    <div className="relative h-[250vh] w-full">
      <motion.button
        className="sticky cursor-pointer left-[calc(50%-0.02*var(--draw-width))] -translate-x-1/2 -translate-y-1/2 top-[calc(100vh-0.64*var(--draw-height))] p-4 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-xs border-4 border-indigo-300/50"
        style={{ opacity: progress, scale: progress }}
        onClick={(e) => {
          confetti({
            count: 200,
            position: {
              x: e.clientX,
              y: e.clientY,
            },
          });
        }}
      >
        Click Me
      </motion.button>
      <div ref={ref} className="pointer-events-none absolute top-[100vh] bottom-0" />
    </div>
  );
}
